import { render, staticRenderFns } from "./LoginTestUser.vue?vue&type=template&id=024ec09a"
import script from "./LoginTestUser.vue?vue&type=script&lang=ts"
export * from "./LoginTestUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports